import {
  Grid,
  makeStyles,
  Paper,
  Typography,
  useMediaQuery,
  useTheme
} from "@material-ui/core";
import { ResponsiveBar } from "@nivo/bar";
import { ResponsivePie } from "@nivo/pie";

const CenteredMetric = ({ dataWithArc, centerX, centerY, ...props }) => {
  const theme = useTheme();
  let total = 0;

  dataWithArc.forEach((datum) => {
    total += datum.value;
  });

  return (
    <svg textAnchor="middle" dominantBaseline="central">
      <text
        x={centerX}
        y={centerY - 50}
        style={{
          fontSize: "14px",
          fill: "#707070",
        }}
      >
        Type Of Smart Visa
      </text>
      <text
        x={centerX}
        y={centerY - 30}
        style={{
          fontSize: "14px",
          fill: "#707070",
        }}
      >
        Recipients
      </text>
      <text
        x={centerX}
        y={centerY + 8}
        style={{
          fontSize: "50px",
          fontWeight: "600",
          fill: theme.palette.primary.main,
        }}
      >
        {total}
      </text>
      <text
        x={centerX}
        y={centerY + 40}
        style={{
          fontSize: "12px",
          fill: "#abafc9",
        }}
      >
        persons
      </text>
    </svg>
  );
};

function PieChart() {
  const data = [
    {
      id: "SMART O ( Other )",
      label: "SMART O ( Other )",
      value: 136,
    },
    {
      id: "SMART T ( Talent )",
      label: "SMART T ( Talent )",
      value: 134,
    },
    {
      id: "SMART I ( Investor )",
      label: "SMART I ( Investors )",
      value: 4,
    },
    {
      id: "SMART E ( Executive )",
      label: "SMART E ( Executives )",
      value: 44,
    },
    {
      id: "SMART S ( Startup )",
      label: "SMART S ( Startup )",
      value: 307,
    },
  ];
  return (
    <ResponsivePie
      data={data}
      innerRadius={0.55}
      margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
      animate
      enableSliceLabels={false}
      radialLabel={(d) => `${d.id} (${d.formattedValue})`}
      activeOuterRadiusOffset={8}
      activeInnerRadiusOffset={8}
      arcLinkLabelsThickness={0}
      arcLinkLabelsTextOffset={0}
      arcLinkLabelsStraightLength={0}
      enableArcLabels={false}
      layers={["arcs", "arcLabels", "arcLinkLabels", "legends", CenteredMetric]}
      colors={["#2bb4d4", "#5ce1e6", "#1787ba", "#255b98", "#2d306d"]}
    />
  );
}

function SmartVisaEdorsementBarChart() {
  const theme = useTheme();
  const data = [
    {
      month: "Jan",
      value: 20,
    },
    {
      month: "Feb",
      value: 21,
    },
    {
      month: "Mar",
      value: 22,
    },
    {
      month: "Apr",
      value: 23,
    },
    {
      month: "May",
      value: 24,
    },
    {
      month: "Jun",
      value: 25,
    },
    {
      month: "Jul",
      value: 58,
    },
    {
      month: "Aug",
      value: 27,
    },
    {
      month: "Sep",
      value: 28,
    },
    {
      month: "Oct",
      value: 29,
    },
    {
      month: "Nov",
      value: 30,
    },
    {
      month: "Dec",
      value: 31,
    },
  ];

  return (
    <ResponsiveBar
      data={data}
      indexBy="month"
      keys={["value"]}
      margin={{ top: 0, right: 0, bottom: 60, left: 40 }}
      labelTextColor="inherit:darker(1.4)"
      labelSkipWidth={16}
      labelSkipHeight={16}
      layout="horizontal"
      enableGridY={false}
      enableGridX={true}
      enableLabel={false}
      axisLeft={{
        tickSize: 0,
        tickPadding: 15,
        tickRotation: 0,
      }}
      axisBottom={{
        tickSize: 0,
        tickPadding: 15,
        tickRotation: 0,
      }}
      colors={["#00c2cb"]}
    />
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    padding: theme.spacing(4),
    borderRadius: 16,
    marginTop: theme.spacing(4),
  },
  wrapHeader: {
    borderRadius: theme.shape.borderRadius,
  },
  wrapChart: {
    height: 488,
    paddingTop: theme.spacing(4),
  },
  wrapTimeBarChart: {
    display: "flex",
    flexDirection: "column",
  },
  wrapBarChart: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    height: 488,
    paddingRight: theme.spacing(2),
    [theme.breakpoints.up("lg")]: {
      height: 400,
    },
  },
}));

export default function TargetIndustries() {
  const theme = useTheme();
  const classes = useStyles();

  const isMD = useMediaQuery(theme.breakpoints.up("lg"));

  return (
    // <Paper className={classes.paper}>
    //   <div className={classes.wrapHeader}>
    //     <Typography
    //       variant="h6"
    //       style={{ color: theme.palette.darkIndigo.main }}
    //     >
    //       Number of successful applicants by targeted industries
    //     </Typography>
    //     <Typography variant="h4" color="secondary">
    //       Targeted industries
    //     </Typography>
    //   </div>
    //   <Grid container>
    //     <Grid item xs={12} lg={8}>
    //       <div className={classes.wrapChart}>
    //         <PieChart />
    //       </div>
    //     </Grid>
    //     <Grid item xs={12} lg={4}>
    //       <div className={classes.wrapBarChart}>
    //         <div className={classes.wrapTimeBarChart}>
    //           <Typography variant="p">Smart Visa Endorsement</Typography>
    //           <Typography variant="p" color="primary">
    //             by month
    //           </Typography>
    //         </div>
    //         <SmartVisaEdorsementBarChart />
    //       </div>
    //     </Grid>
    //   </Grid>
    // </Paper>
    <Paper className={classes.paper}>
      <div className={classes.wrapHeader}>
        <Typography
          variant="h6"
          style={{ color: theme.palette.darkIndigo.main }}
        >
          {/* Number of successful applicants by targeted industries */}
        </Typography>
        <Typography variant="h4" color="secondary">
          {/* Targeted industries */}
        </Typography>
      </div>
      <Grid container>
        <Grid item xs={12} lg={12}>
          <img
            src="/assets/images/LTR_Timeline.jpg"
            alt="smart-visa-logo"
            style={{
              width: "100%",
              //height: 52
            }}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}
